import * as tslib_1 from "tslib";
import { getRowKeysFromRowIds } from 'owa-mail-list-store';
import selectConversationById from 'owa-mail-list-store/lib/selectors/selectConversationById';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import getTableConversationRelation from 'owa-mail-list-store/lib/utils/getTableConversationRelation';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('removeSingleItemFromConversation', function removeSingleItemFromConversation(itemContext, tableViewId) {
    var e_1, _a;
    var tableView = listViewStore.tableViews.get(tableViewId);
    var rowKeys = getRowKeysFromRowIds([itemContext.conversationId], tableView);
    try {
        for (var rowKeys_1 = tslib_1.__values(rowKeys), rowKeys_1_1 = rowKeys_1.next(); !rowKeys_1_1.done; rowKeys_1_1 = rowKeys_1.next()) {
            var rowKey = rowKeys_1_1.value;
            removeSingleItemFromConversationByRowKey(rowKey, itemContext, tableViewId);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (rowKeys_1_1 && !rowKeys_1_1.done && (_a = rowKeys_1.return)) _a.call(rowKeys_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
});
function removeSingleItemFromConversationByRowKey(rowKey, itemContext, tableViewId) {
    var conversationItem = selectConversationById(itemContext.conversationId);
    var tableConversationRelation = getTableConversationRelation(rowKey, tableViewId);
    // Remove from ItemIds if found
    var removeAtIndex = tableConversationRelation.itemIds.indexOf(itemContext.itemId);
    if (removeAtIndex >= 0) {
        tableConversationRelation.itemIds.splice(removeAtIndex, 1);
        // Also update unread count
        if (!itemContext.isRead) {
            tableConversationRelation.unreadCount--;
        }
    }
    // Remove from GlobalItemIds if found
    removeAtIndex = conversationItem.globalItemIds.indexOf(itemContext.itemId);
    if (removeAtIndex >= 0) {
        conversationItem.globalItemIds.splice(removeAtIndex, 1);
        // Also update global unread count
        if (!itemContext.isRead) {
            conversationItem.globalUnreadCount--;
        }
    }
    // Remove from DraftItemIds if found
    removeAtIndex = tableConversationRelation.draftItemIds.indexOf(itemContext.itemId);
    if (removeAtIndex >= 0) {
        tableConversationRelation.draftItemIds.splice(removeAtIndex, 1);
    }
}
//# sourceMappingURL=removeSingleItemFromConversationMutator.js.map